import { assign } from 'xstate';

import { initialContext } from '../../Reorder.machine.constants';
import { type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const resetContext: ReorderMachineAction = assign(() => initialContext);
